import Player from '@vimeo/player';
import * as tts from "./tts";
import {Router} from "./router";
import {getLang} from "./helpers";

const lang = getLang();


export const initPlayers = () => {
    const players = document.querySelectorAll('.player');
    Array.from(players).forEach(initPlayer);

    document.addEventListener('nextResultsFetched', event => {
        event.detail.forEach(slug => {
            const playerCtn = document.querySelector(`[data-slug=${slug}]`);

            if (playerCtn) {
                initPlayer(playerCtn);
            }
        });
    });
}

const initPlayer = playerCtn => {
    let player = new Player(playerCtn, {
        url: playerCtn.getAttribute('data-video-url'),
        byline: false,
        portrait: false,
        color: 'FFFFFF',
        pip: true
    });

    player.ready()
        .then(() => {
            toggleCover(playerCtn, player);
        })
        .catch(() => {
            playerCtn.parentElement.addEventListener('click', () => {
                showError('talk.video_error');
            });
        });

    player.on('ended', () => {
        toggleTitle(playerCtn);
        toggleCover(playerCtn, player);
    });
}

const toggleTitle = playerCtn => {
    playerCtn.parentElement.querySelector('.talk-title').classList.toggle('d-none');
}

const toggleCover = (playerCtn, player) => {
    const cover = playerCtn.parentElement.querySelector('.walk-cover');

    if (!cover) {
        return;
    }

    if (cover.classList.contains('d-none') === true) {
        cover.classList.remove('d-none');

        return;
    }

    cover.addEventListener('click', () => {
        const spinner = playerCtn.querySelector('.spinner-container');
        spinner.classList.toggle('loading');

        player.play().then(() => {
            toggleTitle(playerCtn);
            cover.classList.toggle('d-none');
            spinner.classList.toggle('loading');
            tts.custom({
                event: 'video_play',
                uri: Router.generate('walk_show.' + lang, {
                    slug: playerCtn.getAttribute('data-slug')
                })
            }, 'walk_show');
        });
    });
}

const showError = message => {
    const flashContainer = document.querySelector('.flash');

    if (!flashContainer) {
        return;
    }

    const className = 'alert fade show mb-3 alert-error';
    flashContainer.innerHTML = `<div class="${className}">${Translator.trans(message)}</div>`;

    flashContainer.scrollIntoView({behavior: "smooth", block: "center"});
    setTimeout(() => flashContainer.innerHTML = '', 5000);
};
